/**
 * TODO: to be split into smaller packages when the time is right.
 *   For example: @printdeal/sentry, @printdeal/optimizely, etc.
 *
 * For now, this is implemented as 1 class to make the first move to the JS packages repo
 * a bit easier.
 *
 * Once this is split up into smaller packages, this whole class
 * can likely disappear from this package.
 *
 * @deprecated
 */
class ImplementationProvider {
  provideSentryHelper(sentryHelper) {
    this.sentryHelperImplementation = sentryHelper;
  }
  provideCustomerCareComponent(customerCareComponent) {
    this.customerCareComponentImplementation = customerCareComponent;
  }
  get sentryHelper() {
    if (typeof this.sentryHelperImplementation === 'undefined') {
      throw new Error('No SentryHelper implementation provided.');
    }
    return this.sentryHelperImplementation;
  }
  get customerCareComponent() {
    if (typeof this.customerCareComponentImplementation === 'undefined') {
      throw new Error('No CustomerCareComponent implementation provided.');
    }
    return this.customerCareComponentImplementation;
  }
}
const implementationProvider = new ImplementationProvider();
export default implementationProvider;